import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import {
  PostAcceptedPools,
  PostDeleteAcceptedPools,
  PostSiteOrgConfig,
} from "../../api/api";

type SiteOrgConfigResult = {
  status: string;
  notification?: boolean;
  msg?: string;
};

type SiteOrgConfig = {
  siteName: string;
  config: object;
};

export const usePostSiteConfig = () => {
  const { getAccessTokenSilently } = useAuth0();

  const mutation = useMutation({
    mutationFn: ({
      siteName,
      config,
      token,
    }: SiteOrgConfig & {
      token: string;
    }): Promise<SiteOrgConfigResult> =>
      PostSiteOrgConfig(token, {
        siteName: siteName,
        config,
      }),

    onSuccess: (data) => {},

    onError: (error) => {
      console.error(
        "Error performing miner operations:",
        error
      );
    },
  });

  const mutateWithToken = useCallback(
    async (
      { siteName, config }: SiteOrgConfig,
      options?: {
        onSuccess?: (data: SiteOrgConfigResult) => void;
        onError?: (error: any) => void;
        onSettled?: () => void;
      }
    ) => {
      const token = await getAccessTokenSilently();
      console.log();
      mutation.mutate(
        {
          config,
          siteName,
          token,
        },
        {
          onSuccess: options?.onSuccess,
          onError: options?.onError,
          onSettled: options?.onSettled,
        }
      );
    },
    [getAccessTokenSilently, mutation]
  );

  return { ...mutation, mutate: mutateWithToken };
};
